import { type RichContent } from '@wix/ricos';
import React, {
  type ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type SubmitStatus = {
  submitSuccessMessage?: RichContent;
  submitFailureCode?: string;
  submitFailureMessage?: string;
  setSubmitSuccessMessage: (message?: any) => void;
  setSubmitFailureCode: (code?: string) => void;
  setSubmitFailureMessage: (message?: string) => void;
};

const SubmitStatusContext = createContext<SubmitStatus | undefined>(undefined);

export type SubmitStatusProviderProps = {
  children: ReactNode;
};

export const SubmitStatusProvider = ({
  children,
}: SubmitStatusProviderProps) => {
  const [submitSuccessMessage, setSubmitSuccessMessage] =
    useState<RichContent>();
  const [submitFailureCode, setSubmitFailureCode] = useState<string>();
  const [submitFailureMessage, setSubmitFailureMessage] = useState<string>();

  const value: SubmitStatus = useMemo(
    () => ({
      submitSuccessMessage,
      submitFailureCode,
      submitFailureMessage,
      setSubmitSuccessMessage,
      setSubmitFailureCode,
      setSubmitFailureMessage,
    }),
    [submitSuccessMessage, submitFailureCode, submitFailureMessage],
  );

  return (
    <SubmitStatusContext.Provider value={value}>
      {children}
    </SubmitStatusContext.Provider>
  );
};

export const useSubmitStatus = () => {
  const context = useContext(SubmitStatusContext);

  if (context === undefined) {
    throw new Error(
      'useSubmitStatus must be used within a SubmitStatusProvider',
    );
  }

  return context;
};
